import React from "react";

import "./styles/variables.css";
import "./styles/App.css";
import MainPage from "./pages/MainPage";

function App() {
  return <MainPage />;
}

export default App;
